module.exports = __webpack_public_path__ + "static/media/img_Inscription_name2@2x.8bb7c603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_Inscription_name2@2x.png
// module id = 994
// module chunks = 0